<template>
    <div>
        <modal 
        name="createCategoryModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto">
        <div class="v-modal">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title" v-if="callFromEdit && editItem && checkProperty(editItem,'_id')">  Edit Category</h2>
                <h2 class="popup-title" v-else>  Add Category</h2>
                <span @click="$modal.hide('createCategoryModal');hideCategoryMe()">
                <em class="material-icons">close</em>
                </span>
            </div>
            <form @submit.prevent data-vv-scope="addCategoryForm" @click="categorytErr= ''" >
                <div class="form-container" @click="categorytErr=''">
                    <div class="vx-row">
                        <immiInput :display="true"  :wrapclass="'md:w-full'"   cid="categoryName" formscope="addCategoryForm" v-model="categoryName"  :fieldName="'categoryName'"  :required="true"  label="Name" placeHolder="Name" />
                    </div>
                    <div class="vx-row ">
                        <div class="vx-col w-full">
                        <ul
                            class="demo-alignment custom-radio notify_checks"
                            vs-type="flex"
                            vs-align="center">
                            <li> <vs-checkbox vs-name="categoryConfidential"  v-model="categoryConfidential" ><span>Confidential</span></vs-checkbox> </li>
                        </ul>
                        </div>
                    </div>
                    <div class="text-danger text-sm formerrors custom_margin" v-show="categorytErr">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                        icon="IP-information-button" active="true">{{ categorytErr }}</vs-alert>
                    </div>
                    <div class="popup-footer relative">
                        <span class="loader" v-if="loadingCategory" ><img src="@/assets/images/main/loader.gif" /></span>
                        <vs-button color="dark" @click="hideCategoryMe()" class="cancel" type="filled">Cancel</vs-button>
                        <vs-button color="success" @click="addNewCategory()" class="save" type="filled">Submit</vs-button>
                    </div>
                </div>
            </form>
        </div>
        </modal>   
    </div>
</template>
<script>
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import simpleColorPicker from "@/views/forms/fields/simpleColorPicker.vue";
    export default {
        components:{
            simpleColorPicker,
            immiInput,
            selectField
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data: () => ({
            categoryConfidential:false,
            categoryName:'',
            addCategory:false,
            loadingCategory:false,
            categorytErr:'',
        }),
        props:{
            message:{
                type:Object,
                default:null
            },
            callFromEdit:{
                type:Boolean,
                default:false
            },
            callFromList:{
                type:Boolean,
                default:false
            },
            editItem:{
                type:Object,
                default:null
            },
            searchQuery:{
                type:String,
                default:''
            }
        },
        methods:{
            openCategoryPopup(action = false){
                this.categoryName = '';
                this.categoryConfidential = false;
                this.categorytErr= '';
            },
            addNewCategory(){
                this.$validator.validateAll('addCategoryForm').then(result => {
                    if(result){
                        let payLoad={ 
                            name: this.categoryName,
                            confidential: this.categoryConfidential
                        }
                        this.categorytErr = '';
                        let path = '/contact-type/create';
                        if(this.callFromEdit && this.editItem && this.checkProperty(this.editItem,'_id')){
                            payLoad['contactTypeId'] = this.checkProperty(this.editItem,'_id');
                            path = '/contact-type/update';
                        }
                        this.loadingCategory = true;
                        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response)=>{
                            this.showToster({message:response.message ,isError:false});
                            this.loadingCategory = false;
                            this.openCategoryPopup();
                            let pyLoad = {
                                name:this.checkProperty(response, 'name'),
                                _id:this.checkProperty(response, '_id')
                            }
                            this.hideCategoryMe(pyLoad);
                        }).catch((err)=>{
                            this.categorytErr = err;
                            this.loadingCategory = false;
                        })
                    }
                })
            },
            hideCategoryMe(data = null){
                this.openCategoryPopup();
                this.$emit('hideCategoryMe', data)
                this.$modal.hide('createCategoryModal');
                
            },
        },
        mounted(){
            this.openCategoryPopup();
            if(this.callFromEdit && this.editItem && this.checkProperty(this.editItem,'_id')){
                this.categoryName = this.checkProperty(this.editItem,'name');
                this.categoryConfidential = this.checkProperty(this.editItem,'confidential');
            }else if(this.searchQuery != ''){
                this.categoryName = this.searchQuery;
            }
            this.$modal.show('createCategoryModal');
        }
    }


</script>